/* eslint-disable jira/filename-case */
import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import { performPutRequest } from '@atlassian/jira-fetch/src/index.tsx';

type IssueTypeId = string;
type ProjectId = string;

export const performUpdatePinnedFields = (
	{
		projectId,
		issueTypeId,
		pinnedFields,
	}: {
		projectId: ProjectId;
		issueTypeId: IssueTypeId;
		pinnedFields: FieldKey[];
	}, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> =>
	performPutRequest(
		`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}/pinned-fields`,
		{
			body: JSON.stringify({ pinnedFields }),
		},
	);
